export const FEATURES = {
  AI_CONTENT_GENERATION: 'ai-content-generation',
  TRAINING_SCHEDULE: 'training-schedule',
  CREDITS: 'credits',
  OWN_CREDITS: 'own-credits',
  APPROVAL_WORKFLOW: 'approval-workflow',
  SELF_REGISTRATION: 'self-registration',
  LTI: 'lti',
  ZOOM: 'zoom',
  HIDE_PERFORMANCE_DATA: 'hide-performance-data',
  CUSTOM_SENDER_IDENTITY: 'custom-sender-identity',
  CONTENT_SEARCH: 'content-search',
};
